import { useContext, useEffect } from 'react';
import getPartnerConfig from '../../api/getPartnerConfig';
import { UserContext } from '../../context';

const useGetPartnerConfig = () => {
  const [user, { SET_PEP_ATTRIBUTES }] = useContext(UserContext);
  const { countryId, id } = user;

  useEffect(() => {
    if (countryId && id) {
      (async () => {
        try {
          const { pepAttributes = [] } = await getPartnerConfig();
          SET_PEP_ATTRIBUTES(pepAttributes);
        } catch (error) {
          console.error(error);
        }
      })();
    }
  }, [SET_PEP_ATTRIBUTES, countryId, id]);

  return null;
};

export default useGetPartnerConfig;
